export default __webpack_public_path__ + "static/media/main-banner-students.58bd0792.png";